var Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        paddingX: 10,
        paddingY: 10,
        fontSize: 10,
        font: 'Arial',
        attrs: {
            'fill': 'black',
            'text-anchor': 'start',
            'shape-type': 'bottomText' // export only recognizes the attributes, nothing on the node or data
        }
    },
    initialize: function(attrs, options) {
        this.setColor( options.color );
    },
    setColor: function(color) {
        this.get('attrs').fill = color;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/signature/bottomText/uiModel.js
 ** module id = 221
 ** module chunks = 0
 **/